<template>
  <section class="payslip-menu-page" aria-label="工资条管理">
    <iframe title="工资条管理工作区" src="/rjt-payslip-admin/manage" class="payslip-menu-frame" referrerpolicy="same-origin" />
  </section>
</template>
<script>
export default { name: 'PayslipManagement' }
</script>
<style scoped>
.payslip-menu-page { background:#fff; min-height:calc(100vh - 112px); }
.payslip-menu-frame { display:block; width:100%; height:calc(100vh - 112px); min-height:600px; border:0; }
</style>
